module.exports = __webpack_public_path__ + "static/media/Fish_wraps.1fdebc84.png";